// Generated by i18next-cli — review and adapt to your project's needs.
// You may need to install dependencies: npm install i18next react-i18next
//
// Other translation loading approaches:
//   • Static imports or bundled JSON: https://www.i18next.com/how-to/add-or-load-translations
//   • Lazy-load from a server: https://github.com/i18next/i18next-http-backend
//   • Manage translations with your team via Locize: https://www.locize.com
//     (see i18next-locize-backend: https://github.com/locize/i18next-locize-backend)
import i18next from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import deTranslation from './locales/de/translation.json';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import frTranslation from './locales/fr/translation.json';
import ptTranslation from './locales/pt/translation.json';

const savedLanguage: string = JSON.parse(localStorage.getItem('preferences')!)?.locale || 'en';

i18next
  .use(detector)
  .use(initReactI18next)
  .init({
    returnEmptyString: false,
    lng: savedLanguage,
    fallbackLng: 'en',
    defaultNS: 'translation',
    supportedLngs: ['en', 'de', 'fr', 'es', 'pt'],
    resources: {
      en: { translation: enTranslation },
      de: { translation: deTranslation },
      fr: { translation: frTranslation },
      es: { translation: esTranslation },
      pt: { translation: ptTranslation },
    },
  });

export default i18next;
